"use client";

import { useEffect, useState } from "react";
import { Button, InputField } from "@vionixasia/shared-components";
import { AdminShell } from "@/components/AdminShell";
import { apiClient } from "@/lib/api-client";
import { useQueryParam } from "@/lib/use-query-param";
import type { Message } from "@/types/conversation";

export default function ThreadPage() {
  const projectId = useQueryParam("projectId");
  const conversationId = useQueryParam("conversationId");
  const [messages, setMessages] = useState<Message[]>([]);
  const [reply, setReply] = useState("");
  const [sending, setSending] = useState(false);

  async function load() {
    if (!projectId || !conversationId) return;
    const data = await apiClient<{ messages: Message[] }>(`/api/projects/${projectId}/conversations/${conversationId}/messages`);
    setMessages(data.messages);
  }

  useEffect(() => {
    load().catch(() => setMessages([]));
  }, [projectId, conversationId]);

  async function sendReply(event: React.FormEvent) {
    event.preventDefault();
    if (!reply.trim() || !projectId || !conversationId) return;
    setSending(true);
    await apiClient(`/api/projects/${projectId}/conversations/${conversationId}/reply`, {
      method: "POST",
      body: JSON.stringify({ text: reply }),
    });
    setReply("");
    setSending(false);
    await load();
  }

  return (
    <AdminShell>
      <h1 className="text-2xl font-semibold text-ink">Message Thread</h1>
      <div className="mt-6 rounded-card border border-line bg-white p-4">
        <div className="space-y-3">
          {messages.map((message) => (
            <div key={message.id} className={`flex ${message.direction === "outbound" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-xl rounded px-4 py-3 text-sm ${message.direction === "outbound" ? "bg-brand text-white" : "bg-surface text-ink"}`}>
                <p>{message.text || `[${message.type}]`}</p>
                <p className={`mt-2 text-xs ${message.direction === "outbound" ? "text-white/75" : "text-muted"}`}>{message.sender} · {message.whatsapp_status || message.direction}</p>
              </div>
            </div>
          ))}
          {messages.length === 0 && <p className="text-sm text-muted">Belum ada pesan.</p>}
        </div>
        <form onSubmit={sendReply} className="mt-5 flex gap-2">
          <InputField wrapperClassName="min-w-0 flex-1" label="Reply" labelClassName="sr-only" name="reply" value={reply} onChange={(e) => setReply(e.target.value)} placeholder="Tulis balasan WhatsApp" labelColor="text-ink" />
          <Button type="submit" color="teal" disabled={sending || !reply.trim()}>
            {sending ? "Sending..." : "Send"}
          </Button>
        </form>
      </div>
    </AdminShell>
  );
}
